import { render, staticRenderFns } from "./MultipleUploadButtons.vue?vue&type=template&id=552f66ea&"
import script from "./MultipleUploadButtons.vue?vue&type=script&lang=js&"
export * from "./MultipleUploadButtons.vue?vue&type=script&lang=js&"
import style0 from "./MultipleUploadButtons.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports